export const functions = [
    { plural: '', singular: '' },
    { plural: 'Gérants', singular: 'Gérant' },
    { plural: 'Co-gérants', singular: 'Co-gérant' },
    { plural: 'Présidents', singular: 'Président' },
    { plural: 'Présidents-directeurs généraux', singular: 'Président-directeur général' },
    { plural: 'Directeurs généraux', singular: 'Directeur général' },
    { plural: 'Directeurs généraux délégués', singular: 'Directeur général délégué' },
]

export const advencedFunctions = [
    { plural: "Gérants", singular: "Gérant" },
    { plural: "Co-gérants", singular: "Co-gérant" },
    { plural: "Présidents", singular: "Président" },
    { plural: "Présidents-directeurs généraux", singular: "Président-directeur général" },
    { plural: "Directeurs généraux", singular: "Directeur général" },
    { plural: "Directeurs généraux délégués", singular: "Directeur général délégué" },
    { plural: "Présidents du conseil d'administration", singular: "Président du conseil d'administration" },
    { plural: "Présidents du conseil d'admin. et Directeurs Généraux", singular: "Président du conseil d'admin. et Directeur Général" },
    { plural: "Administrateurs", singular: "Administrateur" },
    { plural: "Commissaires aux comptes titulaires", singular: "Commissaire aux comptes titulaire" },
    { plural: "Commissaires aux comptes suppléants", singular: "Commissaire aux comptes suppléant" },
]